// extracted by mini-css-extract-plugin
export default {"wrapper":"empty_wrapper__YytDe","container":"empty_container__YnK0E","title":"empty_title__j85Dm"};